import React from 'react';
import PropTypes from 'prop-types';
import logoImages from 'modules/logos';
import classnames from 'classnames';

import './promo-logo.scss';

const PromoLogo = ({ text, image, url, mobile }) => {
  const classes = classnames({
    'promo-logo': true,
    'promo-logo--mobile': mobile,
  });
  return (
    <div className={classes}>
      <a href={url}>
        {text}
        <img src={logoImages[image]} alt={image} />
      </a>
    </div>
  );
};

PromoLogo.defaultProps = {
  text: '',
  mobile: false,
};

PromoLogo.propTypes = {
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  mobile: PropTypes.bool,
};

export default PromoLogo;
